import urlConfig from './url.config.js'
import aliOSSConfig from './aliOSS.config.js'

// 配置
const origin = window.location.origin
let config = {}
Object.assign(config, aliOSSConfig.default)

if (origin) {
  //不判断，在  IE10上会报错
  if (origin.indexOf('youkehulian.cn') !== -1) {
    // 测试
    config.baseURL = urlConfig.develop
    Object.assign(config, aliOSSConfig.develop)
  } else if (origin.indexOf('catschina.cn') !== -1) {
    // 正式
    config.baseURL = urlConfig.product
    Object.assign(config, aliOSSConfig.product)
  } else {
    config.baseURL = urlConfig.local
    Object.assign(config, aliOSSConfig.develop)
  }
}

export default config
